import React, { createContext, useState } from "react";

const VendedoresContext = createContext();

const VendedoresContextProvider = ({ children }) => {
  //Geral
  const [geralVendedorId, setGeralVendedorId] = useState(null);
  const [geralCpfcnpj, setGeralCpfCnpj] = useState("");
  const [disabledInputCnpj, setDisabledInputCnpj] = useState(false);
  const [expanded, setExpanded] = useState({ general: true });
  const [geralRazao, setGeralRazao] = useState("");
  const [geralFantasia, setGeralFantasia] = useState("");
  const [geralCep, setGeralCEP] = useState("");
  const [geralEndereco, setGeralEndereco] = useState("");
  const [geralNumero, setGeralNumero] = useState("");
  const [geralComplemento, setGeralComplemento] = useState("");
  const [geralBairro, setGeralBairro] = useState("");
  const [geralEstado, setGeralEstado] = useState(null);
  const [geralMunicipio, setGeralMunicipio] = useState(null);
  const [geralPais, setGeralPais] = useState({
    codigo: "1058",
    descricao: "BRASIL",
    siscomex: "105",
  });
  const [geralDdd, setGeralDdd] = useState("");
  const [geralTel1, setGeralTel1] = useState("");
  const [geralTel2, setGeralTel2] = useState("");
  const [geralTel3, setGeralTel3] = useState("");
  const [geralEmail, setGeralEmail] = useState("");
  const [geralComissaoVenda, setGeralComissaoVenda] = useState("");
  const [geralTipoVendedor, setGeralTipoVendedor] = useState("");
  const [geralRegiaoComercial, setGeralRegiaoComercial] = useState("");
  const [geralEmpresa, setGeralEmpresa] = useState("");
  const [geralCarteiraPropria, setGeralCarteiraPropria] = useState(null);
  const [geralAtivo, setGeralAtivo] = useState(true);
  const [geralInfos, setGeralInfos] = useState([]);
  const [dataSellerEdit, setDataSellerEdit] = useState({});
  const [geralComission, setGeralComission] = useState("");

  //Tela
  const [open, setOpen] = useState(false);
  const [geralErrors, setGeralErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [sellerType] = useState([
    {
      value: "I",
      label: "Vendedor Interno",
    },
    {
      value: "R",
      label: "Representante Externo",
    },
    {
      value: "T",
      label: "Televendas",
    },
    {
      value: "P",
      label: "Parceiros Externos",
    },
    {
      value: "C",
      label: "Operador de Caixa",
    },
  ]);
  const [listCommercialRegion, setListCommercialRegion] = useState([]);
  const [listUf, setListUf] = useState([]);
  const [listCounty, setListCounty] = useState([]);
  const [listNation, setListNation] = useState([]);
  const [listBank, setListBank] = useState([]);
  const [listCompanies, setListCompanies] = useState([]);
  const [listComissions, setListComissions] = useState([]);
  const [loadingInputs, setLoadingInputs] = useState({});
  const listOptionsPix = [
    {
      label: "CPF/CNPJ",
    },
    {
      label: "Telefone",
    },
    {
      label: "Email",
    },
    {
      label: "Outros",
    },
  ];
  const [validCpfCnpj, setValidCpfCnpj] = useState(false);

  //Banco
  const [bank, setBank] = useState([]);

  return (
    <VendedoresContext.Provider
      value={{
        open,
        setOpen,
        loading,
        setLoading,
        sellerType,
        listCommercialRegion,
        setListCommercialRegion,
        expanded,
        setExpanded,
        geralCpfcnpj,
        setGeralCpfCnpj,
        geralErrors,
        setGeralErrors,
        disabledInputCnpj,
        setDisabledInputCnpj,
        geralRazao,
        setGeralRazao,
        geralFantasia,
        setGeralFantasia,
        geralCep,
        setGeralCEP,
        geralEndereco,
        setGeralEndereco,
        geralNumero,
        setGeralNumero,
        geralComplemento,
        setGeralComplemento,
        geralBairro,
        setGeralBairro,
        geralEstado,
        setGeralEstado,
        geralMunicipio,
        setGeralMunicipio,
        geralPais,
        setGeralPais,
        geralDdd,
        setGeralDdd,
        geralTel1,
        setGeralTel1,
        geralTel2,
        setGeralTel2,
        geralTel3,
        setGeralTel3,
        geralEmail,
        setGeralEmail,
        geralComissaoVenda,
        setGeralComissaoVenda,
        geralTipoVendedor,
        setGeralTipoVendedor,
        geralRegiaoComercial,
        setGeralRegiaoComercial,
        geralEmpresa,
        setGeralEmpresa,
        geralCarteiraPropria,
        setGeralCarteiraPropria,
        geralAtivo,
        setGeralAtivo,
        listUf,
        setListUf,
        listCounty,
        setListCounty,
        listNation,
        setListNation,
        listCompanies,
        setListCompanies,
        loadingInputs,
        setLoadingInputs,
        listOptionsPix,
        bank,
        setBank,
        listBank,
        setListBank,
        geralInfos,
        setGeralInfos,
        geralVendedorId,
        setGeralVendedorId,
        dataSellerEdit,
        setDataSellerEdit,
        listComissions,
        setListComissions,
        geralComission,
        setGeralComission,
        validCpfCnpj,
        setValidCpfCnpj,
      }}
    >
      {children}
    </VendedoresContext.Provider>
  );
};

export { VendedoresContext, VendedoresContextProvider };
